import React from 'react'

import cn from 'classnames'

interface ChainSelectorProps {
    chains: Record<string, any>
    selectedChain: number | string
    onChainClicked: (chainId: number) => void
    disabledChains?: number[]
    highlightedChain?: number
    tokenQuery: string
    activeChainSelection?: number
    isMobile: boolean
}

export const ChainSelector: React.FC<ChainSelectorProps> = ({
    chains,
    selectedChain,
    onChainClicked,
    disabledChains,
    highlightedChain,
    tokenQuery,
    activeChainSelection,
    isMobile,
}) => {
    return (
        <>
            {Object.entries(chains)
                .sort(([networkIdA], [networkIdB]) => {
                    if (+networkIdA === +selectedChain) return -1
                    if (+networkIdB === +selectedChain) return 1
                    return 0
                })
                .map(([networkId, chain]) => (
                    <button
                        key={`network-${isMobile ? 'mobile-' : ''}${networkId}`}
                        onClick={() => onChainClicked(+networkId)}
                        disabled={disabledChains?.includes(+networkId) && +networkId !== +selectedChain}
                        className={cn(
                            isMobile
                                ? 'flex flex-col items-center justify-center gap-0.5 rounded-md px-1 py-1.5 transition-colors duration-200'
                                : 'flex w-full items-center gap-2 rounded-md px-3 py-2 transition-colors duration-200 disabled:cursor-not-allowed disabled:opacity-50',
                            +networkId === +selectedChain
                                ? 'border border-token-modal-border bg-token-modal-chain-selected'
                                : isMobile
                                  ? 'hover:bg-token-modal-chain-hover'
                                  : highlightedChain === +networkId
                                    ? 'bg-token-modal-chain-selected'
                                    : 'hover:bg-token-modal-chain-hover',
                            !isMobile &&
                                tokenQuery &&
                                activeChainSelection === +networkId &&
                                'border border-token-modal-accent-blue'
                        )}
                        type='button'
                    >
                        <img
                            src={chain.icon}
                            alt={chain.name}
                            className={isMobile ? 'h-6 w-6 rounded-full' : 'h-5 w-5 rounded-full'}
                        />
                        <span
                            className={
                                isMobile
                                    ? 'w-full truncate text-center text-[10px] font-medium'
                                    : 'text-[14px] font-medium'
                            }
                        >
                            {chain.name}
                        </span>
                    </button>
                ))}
        </>
    )
}

export default ChainSelector
